import React, { createContext, useEffect, useState } from "react"
import apiHandler from "../common/config/apiHandler"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
export const DataContext = createContext()

export const DataProvider = ({ children }) => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [bookingDetails, setBookingDetails] = useState({})
  const [bookingHistory, setBookingHistory] = useState({})
  const [bookings, setBookings] = useState([])
  const [token, setToken] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [sites, setSites] = useState([])

  const [companies, setCompanies] = useState([])

  const [airports, setAirports] = useState([])
  const [subscribeKey, setSubscribeKey] = useState("")
  const [public_key, setPublic_key] = useState("")

  const navigate = useNavigate()

  const handleFetchBookingDetails = async bookingID => {
    try {
      const response = await apiHandler({
        endpoint: `/backend/bookings/bookingDetails/${bookingID}`,
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      setBookingDetails(response?.data)
    } catch (err) {
      console.error("Error fetching booking details:", err)
      setError(err)
      // @ts-ignore
      if (err?.response?.status == 401) {
        toast.error("Token Expired.. Redirecting to Login Page.....")
        setTimeout(() => {
          navigate("/login")
        }, 2000)
      }
    } finally {
      setLoading(false)
    }
  }

  const fetchSites = async () => {
    try {
      const response = await apiHandler({
        endpoint: "/backend/sites",
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })

      setSites(response.data)
    } catch (err) {
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
      setError(err)
    }
  }

  const fetchCompanies = async () => {
    try {
      const response = await apiHandler({
        endpoint: "/backend/companies",
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })
      setCompanies(response?.data?.rows)
    } catch (err) {
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
      setError(err)
    }
  }

  const fetchAirports = async () => {
    try {
      const response = await apiHandler({
        endpoint: "/backend/airports",
        method: "GET",
        options: {
          "x-access-token": token || localStorage.getItem("token"),
        },
      })
      setAirports(response?.data)
    } catch (err) {
      toast.error("Token Expired.. Redirecting to Login Page.....")
      setTimeout(() => {
        navigate("/login")
      }, 2000)
      setError(err)
    }
  }

  const fetchSubscribeKey = async (tag, site_id) => {
    if (site_id) {
      try {
        const response = await apiHandler({
          endpoint: "/backend/sites/get_stripe_key",
          method: "POST",
          options: {
            "x-access-token": localStorage.getItem("token"),
          },
          data: {
            api_tag: tag,
            site_id,
          },
        })

        if (response.code == 200) {
          setPublic_key(response?.data?.key)
          setSubscribeKey(response?.data?.subscriber)
        }
      } catch (err) {
        setError(err)
      }
    }
  }
  const calculateTotalAmount = details => {
    if (!details) return 0

    let total = 0

    total += parseFloat(details.cancellation_charges) || 0
    total += parseFloat(details.sms_charges) || 0
    total += parseFloat(details.admin_charges) || 0
    total += parseFloat(details.amount) || 0
    total += parseFloat(details.levy_charges) || 0
    total += parseFloat(details.extra_charges) || 0
    total -= parseFloat(details.discount) || 0

    return parseFloat(total.toFixed(2))
  }

  return (
    <DataContext.Provider
      value={{
        email,
        password,
        token,
        setToken,
        bookingDetails,
        setBookingDetails,
        bookingHistory,
        setBookingHistory,
        bookings,
        setBookings,
        setPassword,
        handleFetchBookingDetails,
        fetchAirports,
        fetchCompanies,
        fetchSites,
        calculateTotalAmount,
        sites,
        airports,
        companies,
        fetchSubscribeKey,
        subscribeKey,
        public_key,
        setEmail,
      }}
    >
      {children}
    </DataContext.Provider>
  )
}
